import React, { Fragment } from 'react';
import { TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import Table from '../../../../../components/material-ui/adaptive/Table';
import MyTableCell from '../../../../../components/material-ui/adaptive/MyTableCell';
import CusInput from '../../../../../components/material-ui/CusInput';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import { useTranslation } from 'react-i18next';
import { styleCellTitle } from '../../../../../components/bonus/ui/styles';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import CusTooltip from '../../../../../components/material-ui/CusTooltip';

export default function JackpotsTable({ currentBonus, superUser, changeField }) {
  const { t } = useTranslation();

  console.log('currentBonus', currentBonus);

  return (
    <TableContainer sx={{ minWidth: { sm: '350px' } }}>
      <Table>
        <TableHead>
          <TableRow>
            <MyTableCell style={styleCellTitle} isLess>
              {t('Currency')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              <CusTooltip
                text={
                  'Initial value - this is the amount from which the Jackpot bank will accumulate each time the player hits it.'
                }
              />
              {t('Initial value')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              <CusTooltip text={'The minimum total bet made by a player in a game.'} />
              {t('Min total rate')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              <CusTooltip text={'Minimum Jackpot pot amount.'} />
              {t('Minimum amount')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              <CusTooltip text={'Maximum Jackpot pot amount.'} />
              {t('Maximum amount')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              <CusTooltip
                text={
                  'The jackpot can only be won by those players who have made deposits (excluding the replenishment commission) in the specified amount within the number of days prior to the jackpot being won.'
                }
              />
              {t('Minimum deposit amount')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              {t('Per number of days')}
            </MyTableCell>
            <MyTableCell style={styleCellTitle} isLess>
              {t('Current amount')}
            </MyTableCell>
            <ShowContainer condition={superUser}>
              <MyTableCell style={styleCellTitle} isLess>
                {t('Actions')}
              </MyTableCell>
            </ShowContainer>
          </TableRow>
        </TableHead>

        <TableBody>
          {Object.keys(currentBonus?.values)?.map((currency) => {
            const bonusInfo = currentBonus.values?.[currency] || {};
            const onChangeField = (val, name) => {
              changeField(currency, name, val);
            };

            return (
              <TableRow key={currency}>
                <MyTableCell style={styleCellTitle} isLess>
                  {currency?.toUpperCase()}
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.initial}
                    onChange={(e) => onChangeField(e.target.value, 'initial')}
                    type="number"
                    inputProps={{ min: 0 }}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.minBet}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'minBet')}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.minAmount}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'minAmount')}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.maxAmount}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'maxAmount')}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.minDeposit}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'minDeposit')}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.depositDays}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'depositDays')}
                  />
                </MyTableCell>
                <MyTableCell isLess>
                  <CusInput
                    value={bonusInfo.amount}
                    type="number"
                    inputProps={{ min: 0 }}
                    onChange={(e) => onChangeField(e.target.value, 'amount')}
                  />
                </MyTableCell>
                <ShowContainer condition={superUser}>
                  <MyTableCell isLess>
                    <CusCheckbox
                      label={'Throw'}
                      checked={bonusInfo.forcedDrop}
                      onChange={() => onChangeField(!bonusInfo.forcedDrop, 'forcedDrop')}
                    />
                  </MyTableCell>
                </ShowContainer>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
